import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api.js';
import { t } from '../i18n.js';

/**
 * Opnieuw controleren: de versies nu uit de FMC halen en opnieuw met Cisco en CISA KEV vergelijken, voor alle bronnen,
 * en de AnyConnect-versies met NVD. Zonder deze knop gebeurt dat elke zes uur; na een upgrade wil je niet zo lang
 * wachten. Zie docs/besluiten/kwetsbare-versies.md en anyconnect-versies.md.
 */
export default function VersiesOphalen() {
  const client = useQueryClient();
  const [bezig, zetBezig] = useState(false);
  const [uitkomst, zetUitkomst] = useState(null);

  const haal = async () => {
    zetBezig(true); zetUitkomst(null);
    try {
      const { data: u } = await api.versiesOphalen();
      zetUitkomst({ goed: !u.fouten, tekst: u.fouten
        ? t('Opgehaald, met {n} fouten: zie de bron', { n: u.fouten })
        : u.versies ? t('{n} versies gewijzigd', { n: u.versies }) : t('Geen versie gewijzigd') });
      await client.invalidateQueries({ queryKey: ['bronnen'] });
      await client.invalidateQueries({ queryKey: ['bron'] });
    } catch (err) {
      zetUitkomst({ goed: false, tekst: t(err.message) });
    } finally {
      zetBezig(false);
    }
  };

  return (
    <span className="rij" style={{ gap: 8 }}>
      {uitkomst && <span className={uitkomst.goed ? 'muted' : undefined} style={uitkomst.goed ? undefined : { color: 'var(--st-warning-ink)' }} role="status">{uitkomst.tekst}</span>}
      <button type="button" className="btn" disabled={bezig} onClick={haal}
        title={t('De versies en de AnyConnect-pakketten nu uit de FMC halen en opnieuw vergelijken met Cisco, NVD en CISA KEV')}>
        {bezig ? t('Controleren…') : t('Opnieuw controleren')}</button>
    </span>
  );
}
